module.exports = __webpack_public_path__ + "media/images/front/common/icon_arrow_right-0ad5bdc01be48bfd6e9a3ef19273beeb.svg";